import React from 'react'
import { Form, Input, FormGroup, FormText } from 'reactstrap'
// import{ AiOutlineSearch} from 'react-icons/ai'
import searchIcon from '../../../Assets/outline-interface-search.png'
import crossIcon from '../../../Assets/group-383.png'
// import { RxCross2 } from 'react-icons/rx'
// import { TextInput } from 'react-native-gesture-handler'
export default function SearchBar(props) {
   
    return (
            <div style={{ flexDirection: 'row', display: 'flex', height: 48,width: props.width}}>
                <div style={searchIconStyle}>
                    <img src={searchIcon} style={searchImgStyle} />
                </div>
                <Input
                    // placeholderTextColor='#9d9d9d'
                    style={searchBoxOfferStyle}
                    onChange={props.onChange}
                    value={props.value}
                    placeholder={props.placeholder}
                    onSubmitEditing={props.onSubmitEditing}
                    // returnKeyType={props.returnKeyType}
                    className='shadow-none'
                    id="inputID"
                    maxLength={props.maxLength || 50}
                    
                />
                <div style={micStyle}>
                    {
                        props.searchTextService && <div style={{ justifyContent: 'center',backgroundColor: 'white',cursor:'pointer' }} onClick={props.onClickCross}>
                            <img src={crossIcon} onClick={props.onPressCross} style={searchImgStyle} />
                        </div>
                    }
                </div>
            </div>
)
}
let searchImgStyle = {
    width: 23,
    height: 24,
    // flexGrow: 0,
    // margin: 0 16px 0 0;
}
let searchIconStyle = {
    position:'absolute',
    left:15,
    top:12,
    right:12
}
let micStyle = {
    position:'absolute',
    // left:10,
    top:12,
    right:12
}
let searchBoxOfferStyle = {
    flex: 1,
    height: 48,
    padding: "10px 10px 10px 50px",
    borderRadius: 12,
    // backgroundColor: "rgba(245, 245, 245, 0.6)",
    shadowColor: "rgba(103, 52, 204, 0.1)",
    shadowOffset: {
        width: 0,
        height: 2
    },
    shadowRadius: 4,
    shadowOpacity: 1,
    borderStyle: "solid",
    // borderWidth: 0.5,
    borderColor: "#e8e8e8",
    backgroundColor: "#fff",
    borderWidth: 1,
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: "bold",
    fontStyle: "normal",
    letterSpacing: 0,
    color: "#9f9f9f",
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flexStart',
    alignItems: 'flexStart',
    borderRadius: 12,
}
    // borderShadow: 'none'

    // placeholderTextColor:'rgb(157, 157, 157)'
